function getSaler(callback) {
  let url = "https://xt-sale.betatechgroup.com/getSaleAust";

  $.ajax({
    type: "get",
    url,
    dataType: "json",
    success: callback,
  });
}

function setSaler(obj) {
  console.log("setSaler ===>", obj);
  if (!obj) {
    return;
  }
  const { saler, code } = obj;
  if (code === 200) {
    localStorage.setItem("saler_xballa", saler);
  }
}

function initTeamColor() {
  console.log("initTeamColor ==>", 111);
  let result = {};
  $(".checkbox_input").on("click", function () {
    const id = $(this).attr("id");
    const val = $(this).val();
    if (!result[id]) {
      result[id] = val;
    } else {
      result[id] = "";
    }
    const values = Object.values(result).filter((item) => item);
    $("#ContactForm #TeamColor").val(values.join(","));
    console.log("initTeamColor result values==>", result, values);
  });
}

const saleman_action = {
  PEI: "https://formspree.io/f/manevrqv",
  Leo: "https://formspree.io/f/mrbgbeba",
};

const saleman_what_no = {
  PEI: "+8613717999369",
  Leo: "+8617813324969",
};

function handleWhats(params) {
  if (!params) {
    return;
  }
  const { saler, code } = params;
  if (code !== 200) {
    return;
  }
  let numbers = saleman_what_no[saler];
  let whaturl = "https://wa.me/" + numbers;
  window.open(whaturl, "_blank");
}

function openWhats() {
  // fbq("track", "Contact");
  getSaler(handleWhats);
}

const numberReg = /^\d{9,}$/;

function scrollFormTop() {
  const contactform = document.getElementById("landingForm");
  contactform.scrollIntoView();
}

function checkForm() {
  const name = $("#ContactForm #ContactForm-name");
  const email = $("#ContactForm #ContactForm-email");
  const phone = $("#ContactForm #ContactForm-phone");
  const whatsApp = $("#ContactForm #ContactForm-whatsApp");
  const errorTip = $("#error-tip");
  const errorWrap = $(".form-error-status");
  console.log("name===>", name.val());
  if (!name.val()) {
    errorWrap.show();
    errorTip.html("name is invalid!");
    errorTip.attr("href", "#ContactForm-name");
    scrollFormTop();
    return false;
  }
  if (!email.val()) {
    errorWrap.show();
    errorTip.html("email is invalid!");
    errorTip.attr("href", "#ContactForm-email");
    scrollFormTop();
    return false;
  }
  if (!phone.val()) {
    errorWrap.show();
    errorTip.html("phone is invalid!");
    errorTip.attr("href", "#ContactForm-phone");
    scrollFormTop();
    return false;
  }
  if (!whatsApp.val()) {
    errorWrap.show();
    errorTip.html("whatsApp is invalid!");
    errorTip.attr("href", "#ContactForm-whatsApp");
    scrollFormTop();
    return false;
  }

  return true;
}

// data 销售名称
// 初始化时表单action地址为销售询盘地址
// 初始化广告来源 location.href
function initFormAction(data) {
  const { saler, code } = data || {};
  const lastsaler = localStorage.getItem("saler_xballa");
  const newsaler = saler || lastsaler
  //   写入ad_source
  const ad_source = location.href;
  $("#ContactForm #ad_source").val(ad_source);
  const action = saleman_action[newsaler]
  const submitbtn = document.getElementById("contact_submit");
  const contactform = document.getElementById("ContactForm");
  if (!action) {
    return;
  }
  let loading = false
  $(submitbtn).on("click", function (e) {
    e.preventDefault();
    if(loading){
      return 
    }
    const isvalid = checkForm();
    if (!isvalid) {
      loading=false
      return;
    }
    loading = true
    handleWeixinLog(contactform,newsaler,(res)=>{
      console.log('handleWeixinLog ==>res',res)
      $(contactform).attr("action", action);
      $(contactform).submit();
    })
  });
}

function initSaler(data) {
  setSaler(data);
  initFormAction(data);
}

$(document).ready(function () {
  initTeamColor();
  getSaler(initSaler);
});
